import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUpdateInfoContentProps } from './msg-group-update-info-content';
import { MsgGroupUpdateInfoContent } from './msg-group-update-info-content';

export interface MsgGroupUpdateInfoProps extends MsgGroupUpdateInfoContentProps {}

export const MsgGroupUpdateInfo = memo(function MsgGroupUpdateInfo({
  message,
}: MsgGroupUpdateInfoProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUpdateInfoContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
